import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';

import * as fromRoot from './../../../../store/reducers';
import { AppUiActions } from './../../../../store/actions';

@Component({
    selector: 'nav-button',
    template: require('./nav-button.component.html')
})
export class NavButtonComponent {
    @Input() assessmentTest: PgRendererDto.AssessmentTest;
    @Input() mode: string;

    constructor(
        private store: Store<fromRoot.State>
    ) {
    }

    showNavigationModal() {
        this.store.dispatch(new AppUiActions.ToggleNavigationModal(true));
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/nav-button/nav-button.component.ts